<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在保存我的设置信息...">
      <a-row :gutter="{ xs: 8, sm: 16, md: 24}">
        <a-col :xs="0" :sm="0" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
        <a-col :xs="20" :sm="20" :md="18" :lg="18" :xl="18" :xxl="18">
          <a-card v-if="(current.expert === true)" size="small" title="银行账户设置">
            <a-form :form="account.form" layout="horizontal">
              <a-row>
                <a-col span="10">
                  <a-form-item label="开户银行" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                    <a-select v-decorator="['bank', {rules: [{ required: true, message: '开户银行必须选择!' }], initialValue: account.bank }]">
                      <a-select-option v-for="item in banks" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="银行卡号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                    <a-input v-decorator="['account', {rules: [{ required: true, message: '银行卡号必须填写!' }], initialValue: account.account }]" />
                  </a-form-item>
                  <a-form-item label="开户支行" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                    <a-input v-decorator="['openBank', {rules: [{ required: true, message: '开户支行必须填写!' }], initialValue: account.openBank }]" />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <div class="button-container">
              <div>
                <a-button icon="save" type="primary" style="float:right; margin-left: 24px;" @click="()=>saveAccount()">保存</a-button>
              </div>
            </div>
          </a-card>
          <a-card v-if="(current.doctor === true)" size="small" title="挂号费设置">
            <a-form :form="fee.form" layout="horizontal">
              <a-row>
                <a-col span="8">
                  <a-form-item label="门诊单次挂号费用" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                    <a-input-number :min="0.0" :step="0.01" v-decorator="['amount', {rules: [{ required: true, message: '挂号费必须填写!' }], initialValue: fee.amount }]" placeholder="请输入挂号费" />元
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <div class="button-container">
              <div>
                <a-button icon="save" type="primary" style="float:right; margin-left: 24px;" @click="()=>saveFee()">保存</a-button>
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: "BasicFeeConfig",
  data(){
    return {
      loading:false,
      current:{},
      banks:[{id:'ABC', name:'农业银行'},{id:'BC', name:'中国银行'},{id:'CCB', name:'建设银行'},{id:'ICBC', name:'工商银行'},
        {id:'CMB', name:'招商银行'},{id:'CMBC', name:'民生银行'}],
      fee:{
        form: this.$form.createForm(this),
        amount:0
      },
      account:{
        form: this.$form.createForm(this),
        bank:'',
        account:'',
        openBank:''
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "我的",
      path: ""
    },{
      text: "我的设置",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.$axios.get('/api/clinic/doctor/' + this.current.doctorId + '/fees').then(function(res){
      if(res.msg.flag == 0 && null != res.biz){
        res.biz.forEach(function (e) {
          if(e.business === 'OUTPATIENT'){
            if(e.type === 'REGISTER'){
              self.fee.amount = e.amount;
            }
          }
        });
      }
    },function(){
    });

    this.$axios.get('/api/clinic/doctor/' + this.current.doctorId + '/account').then(function(res){
      if(res.msg.flag == 0){
        if(undefined != res.biz || null != res.biz){
          self.account.account = res.biz.account||'';
          self.account.bank = res.biz.bank||'';
          self.account.openBank = res.biz.openBank||'';
        }
      }else{
        self.$message.error({content: res.msg.message, duration: 2});
      }
    },function(){
    });
  },
  methods:{
    saveAccount:function (){
      const self = this;
      this.account.form.validateFields((err, values) => {
        if (!err) {
          let params={bank:values.bank, account:values.account, openBank:values.openBank};
          this.loading = true;
          this.$axios.post('/api/clinic/doctor/' + this.current.doctorId + '/account/setting', params).then(function(res){
            self.loading = false;
            if(res.msg.flag == 0){
              self.$message.success({content: '医生银行账户设置保存成功', duration: 2});
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(){
            self.loading = false;
          });
        }
      });
    },
    saveFee:function (){
      const self = this;
      this.fee.form.validateFields((err, values) => {
        if (!err) {
          let params=[{type:'REGISTER', amount:values.amount}];
          this.loading = true;
          this.$axios.post('/api/clinic/doctor/' + this.current.doctorId + '/fee/setting', params).then(function(res){
            self.loading = false;
            if(res.msg.flag == 0){
              self.$message.success({content: '医生费用设置保存成功', duration: 2});
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(){
            self.loading = false;
          });
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
